import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { type ITimeLeft, type IDiscountTimeParams, ZERO_TIME_LEFT, TWO_DAYS_MS } from "./consts";

dayjs.extend(duration);

export const getFormattedTimeLeft = (params: IDiscountTimeParams): string => {
    const { days, hours, minutes, seconds } = calculateTimeLeft(params);

    return `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`;
};

export const getIsInDiscount = (params: IDiscountTimeParams): boolean => {
    const timeLeft = calculateTimeLeft(params);
    return !getIsExpired(timeLeft);
};

export const getDiscountEndTime = (): string => {
    const futureDate = dayjs().add(TWO_DAYS_MS, "millisecond");
    return futureDate.format("YYYY-MM-DDTHH:mm:ss");
};

export const getIsExpired = (timeLeft: ITimeLeft) => Object.values(timeLeft).every((value) => value === 0);

export const calculateTimeLeft = ({ discountEndDateFromSettings, discountEndTime }: IDiscountTimeParams): ITimeLeft => {
    const endTimeString = discountEndTime ?? discountEndDateFromSettings;
    if (!endTimeString) {
        return ZERO_TIME_LEFT;
    }

    const now = dayjs();
    const endTime = dayjs(endTimeString);
    if (!endTime.isValid() || now.isAfter(endTime)) {
        return ZERO_TIME_LEFT;
    }

    const difference = endTime.diff(now);
    const duration = dayjs.duration(difference);

    return {
        days: Math.floor(duration.asDays()),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
    };
};
